// extracted by mini-css-extract-plugin
module.exports = {"intro_wrapper":"ulNGZTWN","intro":"Ij5q1_iE","intro_inner":"nL4AaGJZ","item":"BTRsMlYW","icon_img":"WvugHwpG","title":"SdGkgVqW","subtitle":"UX6q3N5_"};